export default __webpack_public_path__ + "locales/bg/FormGallery.json?hash=84bdf733eedd07ac34290e7e38763ddf";